import {Component, OnInit, TemplateRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {CrudComponent} from '../../../../../shared/components/crud/crud.component';
import {BaseResponse} from '../../../../../shared/models/respose/BaseResponse';
import {PaginatedDataResponse} from '../../../../../shared/models/respose/PaginatedDataResponse';
import {ContactType} from '../../../../../shared/models/ContactType';
import {ContactTypeService} from '../../../../services/contact-type.service';
import {Pagination} from '../../../../../shared/models/Pagination';

@Component({
  selector: 'app-contact-types',
  templateUrl: './contact-types.component.html',
  styleUrls: ['./contact-types.component.css']
})
export class ContactTypesComponent extends CrudComponent {
  public paginatedResponse: PaginatedDataResponse<ContactType> = new PaginatedDataResponse<ContactType>(0, [], 0, 0, 0);

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private service: ContactTypeService
  ) {
    super(modalService, fb);
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    this.form = this.fb.group({
      id: [null],
      name: ['', [Validators.required]]
    });
    this.formSearch = this.fb.group({
      name: ['']
    });
    this.updateList({page: 1, elements: this.elements});
  }

  onSubmit({value, valid}: { value: ContactType, valid: boolean }): void {
    if (valid) {
      if (value.id) {
        this.callUpdate(value);
      } else {
        this.callRegister(value);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  onFind({value, valid}: { value: any, valid: boolean }): void {
    this.updateList({page: 1, elements: this.elements});
  }

  updateList(pagination: Pagination = {page: 1, elements: this.elements}): void{
    const contactType: ContactType = this.formSearch.value;
    this.service.getPaginatedList(pagination.elements, pagination.page, contactType, this.order).subscribe(
      (response: BaseResponse<PaginatedDataResponse<ContactType>>) => {
        this.paginatedResponse = response.data;
      }
    );
  }

  openTrashModal(content: TemplateRef<any>, contactType: ContactType): void {
    this.modalService.open(content, {ariaLabelledBy: 'appointment-detail-modal-basic-title'}).result.then((result) => {
      this.service.deleteItem(contactType.id).subscribe(() => this.updateList({page: 1, elements: this.elements}));
    }, (reason) => {
    });
  }

  edit(contactType: ContactType): void {
    this.form.setValue(
      {
        id: contactType.id,
        name: contactType.name
      }
    );
    this.showHideForm();
  }

  callRegister(contactType: ContactType): void {
    this.service.register(contactType).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }

  callUpdate(contactType: ContactType): void {
    this.service.updateItem(contactType, contactType.id).subscribe(response => {
      this.updateList({page: 1, elements: this.elements});
      this.showHideForm();
    });
  }
}
